/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropdownCategory } from './DropdownCategory';
import {
    DropdownCategoryFromJSON,
    DropdownCategoryFromJSONTyped,
    DropdownCategoryToJSON,
    DropdownCategoryToJSONTyped,
} from './DropdownCategory';

/**
 * 
 * @export
 * @interface DropdownOptionResponse
 */
export interface DropdownOptionResponse {
    /**
     * 
     * @type {string}
     * @memberof DropdownOptionResponse
     */
    id: string;
    /**
     * 
     * @type {DropdownCategory}
     * @memberof DropdownOptionResponse
     */
    category: DropdownCategory;
    /**
     * 
     * @type {string}
     * @memberof DropdownOptionResponse
     */
    value: string;
}



/**
 * Check if a given object implements the DropdownOptionResponse interface.
 */
export function instanceOfDropdownOptionResponse(value: object): value is DropdownOptionResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function DropdownOptionResponseFromJSON(json: any): DropdownOptionResponse {
    return DropdownOptionResponseFromJSONTyped(json, false);
}

export function DropdownOptionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropdownOptionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'category': DropdownCategoryFromJSON(json['category']),
        'value': json['value'],
    };
}

export function DropdownOptionResponseToJSON(json: any): DropdownOptionResponse {
    return DropdownOptionResponseToJSONTyped(json, false);
}

export function DropdownOptionResponseToJSONTyped(value?: DropdownOptionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'category': DropdownCategoryToJSON(value['category']),
        'value': value['value'],
    };
}

